import React from 'react';
import GeneralHeader from 'components/common/GeneralHeader';
import { Tabs } from 'antd';
import { Configuration } from 'components/user_default_setting';

const CompanyRecord = () => {
  return (
    <div>
      <GeneralHeader
        icon={'/icons/defalut_setting_ic.svg'}
        pageTitle={'User Default Settings'}
        child={
          <div style={{ marginTop: '50px' }}>
            <Tabs
              style={{ marginTop: '100px' }}
              defaultActiveKey="1"
              items={[
                {
                  key: '1',
                  label: (
                    <div style={{ color: '#0E3063', fontSize: '20px' }}>
                      Configuration
                    </div>
                  ),
                  children: <Configuration />,
                },
                {
                  key: '2',
                  label: (
                    <div style={{ color: '#0E3063', fontSize: '20px' }}>
                      Organization
                    </div>
                  ),
                  children: `Organization`,
                },
                {
                  key: '3',
                  label: (
                    <div style={{ color: '#0E3063', fontSize: '20px' }}>
                      General
                    </div>
                  ),
                  children: `General`,
                },
                {
                  key: '4',
                  label: (
                    <div style={{ color: '#0E3063', fontSize: '20px' }}>
                      Customize Design
                    </div>
                  ),
                  children: `Customize Design`,
                },
              ]}
            />
          </div>
        }
      />
    </div>
  );
};

export default CompanyRecord;
